module.exports = __webpack_public_path__ + "static/media/full.a7bf5eec.svg";